module.exports = __webpack_public_path__ + "media/icons/sport-5e6c39961fe0441ebd4532dbcf576cbe.svg";